import { DetectConsentStatusEnum } from 'src/store/sageAdminApi';

export function resolveConsentStatus(consentStatus?: DetectConsentStatusEnum): string {
    switch (consentStatus) {
        case 'ACCEPTED':
            return 'Consented';
        case 'DECLINED':
            return 'Declined';
        default:
            return 'Not Received';
    }
}
